'use client'

import {type ReactNode, createContext, useRef, useContext} from 'react'
import {useStore} from 'zustand'
import {createUserStore} from '@/store/userStore'

export type UserStoreApi = typeof createUserStore

export interface UserStoreProviderProps {
  children: ReactNode
}

export const UserStoreContext = createContext<UserStoreApi | undefined>(
  undefined,
)

export const UserStoreProvider = ({children}: UserStoreProviderProps) => {
  const storeRef = useRef<UserStoreApi>()
  if (!storeRef.current) {
    storeRef.current = createUserStore
  }

  return (
    <UserStoreContext.Provider value={storeRef.current}>
      {children}
    </UserStoreContext.Provider>
  )
}

export const useUserStore = () => {
  const counterStoreContext = useContext(UserStoreContext)

  if (!counterStoreContext) {
    throw new Error(`useUserStore must be used within UserStoreProvider`)
  }

  return useStore(counterStoreContext, store => store)
}
